"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UISelectableBox = _interopRequireDefault(require("./UISelectableBox"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var SIZE_CLASSES = {
  auto: 'private-selectable-button--auto',
  small: 'private-selectable-button--small',
  large: 'private-selectable-button--large'
};

var UISelectableButton = _react.default.createClass({
  displayName: "UISelectableButton",
  propTypes: {
    'aria-checked': _react.PropTypes.bool,
    block: _react.PropTypes.bool,
    children: _react.PropTypes.node,
    disabled: _react.PropTypes.bool.isRequired,
    name: _react.PropTypes.string,
    onSelectedChange: _react.PropTypes.func,
    readOnly: _react.PropTypes.bool,
    selected: _react.PropTypes.bool,
    showCheckbox: _react.PropTypes.bool,
    size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm', 'lg']), _react.PropTypes.oneOf(['auto'])]).isRequired,
    textLabel: _react.PropTypes.node,
    truncatable: _react.PropTypes.bool,
    type: _react.PropTypes.oneOf(['default', 'checkbox', 'radio']).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      disabled: false,
      readOnly: false,
      selected: false,
      size: 'small',
      truncatable: true,
      type: 'default'
    };
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        name = _this$props.name,
        selected = _this$props.selected,
        showCheckbox = _this$props.showCheckbox,
        size = _this$props.size,
        textLabel = _this$props.textLabel,
        type = _this$props.type,
        truncatable = _this$props.truncatable,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "name", "selected", "showCheckbox", "size", "textLabel", "type", "truncatable"]);

    if (textLabel == null && children == null) {
      _devLogger.default.warn({
        message: 'UISelectableButton: Should provide either textLabel or children.',
        key: 'UISelectableButton: content'
      });
    }

    if (showCheckbox) {
      _devLogger.default.warn({
        message: 'UISelectableButton: The showCheckbox prop is deprecated, please use the `type` prop instead instead.',
        key: 'UISelectableButton: use showCheckbox error'
      });
    }

    if (type === 'radio' && !name) {
      _devLogger.default.warn({
        message: 'UISelectableButton: If type is set to radio you must provide a name',
        key: 'UISelectableButton: no name value'
      });
    }

    var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
    var maybeSelectionMarkClass = longhandSize === 'large' ? '' : "private-selectable-button__label--" + (type === 'default' ? 'no-selection-mark' : 'selection-mark');
    var computedSelectionMarkLocation;

    if (type !== 'default' || showCheckbox) {
      computedSelectionMarkLocation = longhandSize === 'large' ? 'top-right' : 'left';
    }

    return _react.default.createElement(_UISelectableBox.default, (0, _extends2.default)({
      className: (0, _classNames.default)('private-selectable-button', SIZE_CLASSES[longhandSize], className),
      innerClassName: (0, _classNames.default)('private-selectable-button__inner', {
        'private-selectable-button__inner--truncatable': truncatable
      }),
      name: type === 'default' ? undefined : name,
      padded: false,
      selected: selected,
      selectionMarkLocation: computedSelectionMarkLocation,
      type: showCheckbox ? 'checkbox' : type
    }, rest), children, textLabel ? _react.default.createElement("span", {
      className: (0, _classNames.default)('private-selectable-button__label', "private-selectable-button__label--" + (!truncatable ? 'not-' : '') + "truncatable", maybeSelectionMarkClass)
    }, textLabel) : null);
  }
});

var _default = (0, _Controllable.default)(UISelectableButton, ['selected']);

exports.default = _default;
module.exports = exports.default;